/**
 * EventStatus_Entity type guard.
 *
 * @param {any} eventStatusJson EventStatus object from API
 * @returns {boolean} Return true if type is EventStatus_Entity
 */

export default class EventStatus_Entity {
  constructor(eventStatusJson: EventStatus_Entity) {
    this.id = eventStatusJson.id;
    this.name = eventStatusJson.name;
    this.icon = eventStatusJson.icon;
    this.mercuryStageID = eventStatusJson.mercuryStageID;
    this.color = eventStatusJson.color;
    this.colorRead = eventStatusJson.colorRead;
    this.bodyRead = eventStatusJson.bodyRead;
    this.showDetails = eventStatusJson.showDetails;
    this.title = eventStatusJson.title;
    this.ackTitle = eventStatusJson.ackTitle;
    this.buttonLabel = eventStatusJson.buttonLabel;
    this.actionName = eventStatusJson.actionName;
    this.actionMessage = eventStatusJson.actionMessage;
    this.actionText = eventStatusJson.actionText;
    this.actionLink = eventStatusJson.actionLink;
    this.greeting = eventStatusJson.greeting;
    this.canNotify = eventStatusJson.canNotify;
    this.canSelect = eventStatusJson.canSelect;
    this.clearImportantChanges = eventStatusJson.clearImportantChanges;
    this.clearCriticalChanges = eventStatusJson.clearCriticalChanges;
    this.position = eventStatusJson.position;
    this.willNotify = eventStatusJson.willNotify;
    this.subject = eventStatusJson.subject;
    this.karmaPressure = eventStatusJson.karmaPressure;
  }

  id?: number;
  name?: string;
  icon?: string;
  mercuryStageID?: number;
  color?: string;
  colorRead?: string;
  bodyRead?: string;
  showDetails?: boolean;
  title?: string;
  ackTitle?: string;
  /**
   * Label for the single button a SEASON email carries in place of one set of
   * buttons per project. Mercury falls back to "Answer for each project" when
   * this is empty, which is right for a stage whose ask is answered once per
   * project and wrong for one that is not — a contract is a single document, so
   * it wants "Review and sign my contract" and "each" would be a lie.
   */
  buttonLabel?: string;
  actionName?: string;
  actionMessage?: string;
  actionText?: string;
  actionLink?: string;
  greeting?: string;
  canNotify?: boolean;
  canSelect?: boolean;
  clearImportantChanges?: boolean;
  clearCriticalChanges?: boolean;
  position?: number;
  willNotify: string[];
  subject: string;
  karmaPressure: number;
}
